import { useWSModal } from "@wingspanhq/fe-component-library";
import { DefaultDueDateModal } from "./DefaultDueDateModal";

export function useDefaultDueDateModal() {
  return useWSModal(DefaultDueDateModal, {
    title: "Default Due Date (in days)",
    size: "S"
  });
}
